export class Constants {
	public static RESPONSE_HEADER_API_VERSION = 'X-api-version';
	public static RESPONSE_HEADER_LAST_INDEX = 'X-last-index';
	public static PARAM_CACHEABLE = 'cacheable';
	public static PARAM_LANGUAGES = 'languages';
}
